import Grid from '@sport1/react-elements/core/elements/Grid'
import Touchable from '@sport1/react-elements/core/elements/Touchable'
import React, { FunctionComponent } from 'react'
import FilterChip from '..'
import LabelFont from '../../../Theme/Fonts/Label'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type FilterChipCardProps = {
    /** text which is displayed under the image of this Component */
    text: string
    /** url of image to show inside of the chip */
    imageUrl: string
    /** info about imageUrl for seo */
    alt?: string
    /**
     * callback function triggered when chip is pressed
     *
     * @TJS-type function
     */
    onPress?: () => void
    /**
     * the flag determines aspect ratio of the picture, should be true when the icon isFlag
     * */
    isFlag?: boolean
    /** marginRight space */
    marginRight?: number
    /** marginLeft space */
    marginLeft?: number
    /**
     *  The Image type determines aspect ratio and radius of the picture
     *  * @defaultValue DEFAULT
     * */
    imageType: 'DEFAULT' | 'FLAG' | 'PLAYER'
} & TestID

const FilterChipCard: FunctionComponent<FilterChipCardProps> = ({
    imageUrl,
    alt,
    text,
    onPress,
    imageType,
    marginRight,
    marginLeft,
}) => {
    return (
        <Grid
            minWidth={0}
            backgroundColor="pearl"
            borderRadius={4}
            border="1px"
            borderColor="moon-3"
            marginRight={marginRight}
            marginLeft={marginLeft}
        >
            <Touchable expand onPress={onPress}>
                <Grid paddingX={3} paddingY={4}>
                    <FilterChip
                        type="BACKGROUND"
                        imageType={imageType}
                        imageUrl={imageUrl}
                        alt={alt}
                    />
                    <LabelFont textAlign="center" numberOfLines={2}>
                        {text}
                    </LabelFont>
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default FilterChipCard
